import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'

interface UseLeaveCommunityResult {
  leaveCommunity: (path: string) => Promise<void>
  isFetching: boolean
}

export const useLeaveCommunity = (): UseLeaveCommunityResult => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.post,
  })
  return {
    leaveCommunity: (path: string) => fetcher(`${COMMUNITY_API_PREFIX}/${path}/quit`),
    isFetching,
  }
}
